import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, Input, OnInit } from '@angular/core';
import { BaseServices } from '../../kuba.services';
import { FlexiServices } from '../services/flexi.services';
import { ActivatedRoute, Router } from '@angular/router';

import { ArticleContent } from 'src/app/shared/ecpl-article-viewer/interfaces';
import * as _ from 'lodash';
import { HelperService } from 'src/app/_services/helper.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { OHS_Activty, OHS_PerformedDetails } from '../models/flexi';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { FeaturesBaseServices } from '../../features/services/features-base.services';
import { ClassicEditor } from 'ckeditor5';
import { LanguageId } from 'src/app/_models/language-id.enum';

@Component({
  templateUrl: './ohs-plan.component.html',
  standalone: false
})
export class OHSPlanComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  @Input() articleSrc: ArticleContent;
  private readonly notifications = inject(NotificationService);
  addnewrow = 0;
  Data: any;
  Content: any;
  portalId: number;
  businessId: number;
  applicationId: number;
  loading: boolean = false;
  ohsId: number;
  userId: number;
  currentDateTime: any;
  OHSName: string = 'Plan for BHT';
  featureId: number;
  featureKey: number;
  Userrights: any;
  isRegisteredActivityDisabled: any;
  administrateFeatures: any;
  FollowUpActivityFeatures: any;
  OHS_PerfomedDetails: OHS_PerformedDetails;
  initiator: SelectItem[];
  OhsActivity: FormGroup;
  isShowOHSPlanTable: boolean;
  isRMode: boolean;
  canEdit = false;
  public readOnly = false;
  public minToDate: Date | null = null;
  public maxFromDate: Date | null = null;
  public Editor = ClassicEditor;
  public editorConfig = {
    skin: 'moono-lisa',
    language: 'en'
  };
  public tabz = {
    text: ''
  };

  OptionDate: Date;
  Optionstring: any = '';

  constructor(
    private _flexiService: FlexiServices,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router,
    public datapipe: DatePipe,
    private translate: TranslateService,
    public featuresBaseServices: FeaturesBaseServices
  ) {}

  ngOnInit() {
    this.loading = true;
    this.canEdit = this.canEditRemoteOhsPlan();
    this.isRMode = this.canEdit;
    this.readOnly = !this.canEdit;

    this.businessId = BaseServices.BusinessId;
    this.portalId = +BaseServices.PortalId;
    this.userId = BaseServices.UserId;
    this.applicationId = BaseServices.ApplicationId;
    let OHSData = this.route.snapshot.data['OhsData'];
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    this.featureId = workingModule.id;
    this.featureKey = BaseServices.BusinessId;
    if (OHSData != null) {
      this.ohsId = OHSData.Id;
    } else {
      this.ohsId = 0;
    }
    if (this.ohsId == undefined || this.ohsId == null || this.ohsId == 0) {
      this.ohsId = 0;
    } else {
      this.ohsId = OHSData.Id;
    }
    if (OHSData != null) {
      this.Content = OHSData.Data;
      this.tabz.text = this.Content;
    }

    this.translate.stream('SELECT_FOR_INITIATOR').subscribe(val => {
      this.initiator = [];
      this.initiator.push(
        { label: val.OHS, value: 1 },
        { label: val.BUSINESS, value: 2 }
      );
    });

    this._flexiService.getOhsActivityDetailsById(this.ohsId).subscribe(
      result => {
        this.OHS_PerfomedDetails = result || new OHS_PerformedDetails();
        if (!this.OHS_PerfomedDetails.OHS_Activity) {
          this.OHS_PerfomedDetails.OHS_Activity = [new OHS_Activty()];
        }

        this.OHS_PerfomedDetails.PeriodFrom = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodFrom ?? null
        );

        this.OHS_PerfomedDetails.PeriodTo = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodTo ?? null
        );
        if (this.ohsId > 0 && result != null) {
          result.PeriodFrom = HelperService.formatedInputDate(
            result.PeriodFrom
          );
          result.PeriodTo = HelperService.formatedInputDate(result.PeriodTo);
          this.ToDateChanged(result.PeriodTo);
          this.FromDateChanged(result.PeriodFrom);
        } else {
          const today = new Date();
          this.OHS_PerfomedDetails.PeriodFrom =
            HelperService.formatedInputDate(today);
          this.OHS_PerfomedDetails.PeriodTo =
            HelperService.formatedInputDate(today);

          this.ToDateChanged(this.OHS_PerfomedDetails.PeriodTo);
          this.FromDateChanged(this.OHS_PerfomedDetails.PeriodFrom);
        }

        if (this.OHS_PerfomedDetails.OHS_Activity) {
          this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
            x.Deadline = HelperService.formatedInputDate(x.Deadline);
          });
        }
        this.isShowOHSPlanTable = true;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.isShowOHSPlanTable = true;
      }
    );
  }

  private canEditRemoteOhsPlan(): boolean {
    const businessId = +sessionStorage.getItem('RModeBusinessId');
    return (
      BaseServices.IsRmode &&
      businessId > 0 &&
      String(BaseServices.AbsoluteroleId) === '1'
    );
  }

  saveContent() {
    if (!this.canEdit) return;
    this.addnewrow = 0;
    this.loading = true;
    this.OHS_PerfomedDetails.OHS_PlanId = this.ohsId;
    this.OHS_PerfomedDetails.BusinessId = BaseServices.BusinessId;

    if (this.OHS_PerfomedDetails.PeriodFrom) {
      this.OHS_PerfomedDetails.PeriodFrom = this.datapipe.transform(
        this.OHS_PerfomedDetails.PeriodFrom,
        'yyyy-MM-dd'
      );
    }
    if (this.OHS_PerfomedDetails.PeriodTo) {
      this.OHS_PerfomedDetails.PeriodTo = this.datapipe.transform(
        this.OHS_PerfomedDetails.PeriodTo,
        'yyyy-MM-dd'
      );
    }
    this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
      x.CreatedBy = BaseServices.UserId;
      if (x.Deadline != null) {
        x.Deadline = this.datapipe.transform(x.Deadline, 'yyyy-MM-dd');
      } else {
        x.Deadline = null;
      }
    });

    this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
      if (x.OhsPerformedId !== 0) {
        x.OhsPerformedId = 0;
      }
    });

    // Save Activities
    this._flexiService
      .saveOHSActivity(this.OHS_PerfomedDetails)
      .subscribe(result => {
        result.OHS_Activity.forEach(x => {
          x.Deadline = HelperService.formatedInputDate(x.Deadline) as Date;
        });
        this.OHS_PerfomedDetails = result;
        this.ohsId = result.OHS_PlanId || this.ohsId;
        this.OHS_PerfomedDetails.PeriodFrom = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodFrom ?? null
        );

        this.OHS_PerfomedDetails.PeriodTo = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodTo ?? null
        );

        // Save Editor Content
        this.Content = this.tabz.text;
        if (this.ohsId != null && this.ohsId != 0) {
          this.Data = {
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };
          this._flexiService
            .updateOHSData(this.Data, this.ohsId)
            .subscribe(isOhsupdate => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.loading = false;
            });
        } else {
          this.Data = {
            id: null,
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };

          this._flexiService.PostOHSData(this.Data).subscribe(isOhsupdate => {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
          });
        }
      });
  }

  PrintOhs() {
    if (!this.canEdit) return;
    let cloneArticleSrc = _.clone(this.articleSrc);
    if (this.articleSrc !== undefined) {
      this.articleSrc.article.articleDate = null;
    }
    let type = 'pdf';
    let appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
    let Business = JSON.parse(sessionStorage.getItem('RModeBusiness'));
    let businessName = Business
      ? Business.BusinessName
      : appSettings
        ? appSettings.BusinessName
        : 'OHS-Plan';
    let languageId = parseInt(sessionStorage.getItem('languageId'));

    let CultureInfo = 'en-GB';
    switch (languageId) {
      case LanguageId.English:
        CultureInfo = 'en-GB';
        break;
      case LanguageId.Norwegian:
        CultureInfo = 'no-NO';
        break;
      case LanguageId.Swedish:
        CultureInfo = 'sv-SE';
        break;
      case 4:
        CultureInfo = 'pl-PL';
        break;
    }
    this.addnewrow = 0;
    this.loading = true;
    this.OHS_PerfomedDetails.OHS_PlanId = this.ohsId;
    this.OHS_PerfomedDetails.BusinessId = BaseServices.BusinessId;
    let PeriodFrom =
      this.OHS_PerfomedDetails.PeriodFrom.jsdate == undefined
        ? this.OHS_PerfomedDetails.PeriodFrom
        : this.OHS_PerfomedDetails.PeriodFrom.jsdate;
    if (this.OHS_PerfomedDetails.PeriodFrom.jsdate != undefined) {
      this.OHS_PerfomedDetails.PeriodFrom = this.datapipe.transform(PeriodFrom);
    }
    let PeriodTo =
      this.OHS_PerfomedDetails.PeriodTo.jsdate == undefined
        ? this.OHS_PerfomedDetails.PeriodTo
        : this.OHS_PerfomedDetails.PeriodTo.jsdate;
    if (this.OHS_PerfomedDetails.PeriodTo.jsdate != undefined) {
      this.OHS_PerfomedDetails.PeriodTo = this.datapipe.transform(PeriodTo);
    }
    this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
      x.CreatedBy = BaseServices.UserId;
      if (x.Deadline != null) {
        x.Deadline =
          x.Deadline.jsdate != undefined
            ? this.datapipe.transform(x.Deadline.jsdate)
            : this.datapipe.transform(x.Deadline);
      } else {
        x.Deadline = null;
      }
    });

    this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
      if (x.OhsPerformedId !== 0) {
        x.OhsPerformedId = 0;
      }
    });
    this._flexiService
      .saveOHSActivity(this.OHS_PerfomedDetails)
      .subscribe(result => {
        result.OHS_Activity.forEach(x => {
          x.Deadline = HelperService.formatedInputDate(x.Deadline);
        });
        this.OHS_PerfomedDetails = result;
        this.ohsId = result.OHS_PlanId || this.ohsId;
        this.OHS_PerfomedDetails.PeriodFrom = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodFrom ?? null
        );

        this.OHS_PerfomedDetails.PeriodTo = HelperService.formatedInputDate(
          this.OHS_PerfomedDetails?.PeriodTo ?? null
        );

        // Step 2: Save editor content, then generate PDF
        this.Content = this.tabz.text;

        const generatePdf = () => {
          this.subscriptions.push(
            this._flexiService
              .generateOHSFile(
                this.Content,
                this.businessId,
                CultureInfo,
                this.ohsId,
                this.userId
              )
              .subscribe(
                blob => {
                  this.currentDateTime = this.datapipe.transform(
                    new Date(),
                    'dd/MM/yyyy h:mm:ss'
                  );
                  let link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.download = `${this.OHSName}_${businessName}_${
                    this.currentDateTime
                  }.${type.toLowerCase()}`;
                  link.click();
                  this.loading = false;
                },
                error => {
                  
                  this.loading = false;
                }
              )
          );
        };

        if (this.ohsId != null && this.ohsId != 0) {
          this.Data = {
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };
          this._flexiService
            .updateOHSData(this.Data, this.ohsId)
            .subscribe(isOhsupdate => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              generatePdf();
            });
        } else {
          this.Data = {
            id: null,
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };
          this._flexiService.PostOHSData(this.Data).subscribe(isOhsupdate => {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            generatePdf();
          });
        }
      });
  }

  ArchiveAndReset() {
    if (!this.canEdit) return;
    this.confirmationService.confirm({
      message: this.translate.instant('WARNING_MESSAGE'),
      accept: () => {
        let languageId = parseInt(sessionStorage.getItem('languageId'));
        let CultureInfo = 'en-GB';
        switch (languageId) {
          case LanguageId.English:
            CultureInfo = 'en-GB';
            break;
          case LanguageId.Norwegian:
            CultureInfo = 'no-NO';
            break;
          case LanguageId.Swedish:
            CultureInfo = 'sv-SE';
            break;
          case 4:
            CultureInfo = 'pl-PL';
            break;
        }

        this.Content = this.tabz.text;
        this.loading = true;

        const proceedWithActivities = () => {
          this.addnewrow = 0;
          this.OHS_PerfomedDetails.OHS_PlanId = this.ohsId;
          this.OHS_PerfomedDetails.BusinessId = BaseServices.BusinessId;

          if (this.OHS_PerfomedDetails.PeriodFrom) {
            this.OHS_PerfomedDetails.PeriodFrom = this.datapipe.transform(
              this.OHS_PerfomedDetails.PeriodFrom,
              'yyyy-MM-dd'
            );
          }
          if (this.OHS_PerfomedDetails.PeriodTo) {
            this.OHS_PerfomedDetails.PeriodTo = this.datapipe.transform(
              this.OHS_PerfomedDetails.PeriodTo,
              'yyyy-MM-dd'
            );
          }
          this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
            x.CreatedBy = BaseServices.UserId;
            x.Deadline =
              x.Deadline != null
                ? this.datapipe.transform(x.Deadline, 'yyyy-MM-dd')
                : null;
          });
          this.OHS_PerfomedDetails.OHS_Activity.forEach(x => {
            if (x.OhsPerformedId !== 0) {
              x.OhsPerformedId = 0;
            }
          });

          this._flexiService
            .saveOHSActivity(this.OHS_PerfomedDetails)
            .subscribe(result => {
              result.OHS_Activity.forEach(x => {
                x.Deadline = HelperService.formatedInputDate(x.Deadline);
              });
              this.OHS_PerfomedDetails = result;
              this.OHS_PerfomedDetails.PeriodFrom =
                HelperService.formatedInputDate(
                  this.OHS_PerfomedDetails?.PeriodFrom ?? null
                );
              this.OHS_PerfomedDetails.PeriodTo =
                HelperService.formatedInputDate(
                  this.OHS_PerfomedDetails?.PeriodTo ?? null
                );

              if (result != null) {
                this._flexiService
                  .getOhsActivityDetailsById(this.ohsId)
                  .subscribe(result => {
                    const registeredActivities = result.OHS_Activity.filter(
                      activity => activity.RegisteredActivity
                    );
                    const selectedData = registeredActivities.map(activity => ({
                      Title: activity.Activity,
                      Description: activity.Comment,
                      Deadline: activity.Deadline
                    }));

                    this.applicationId = BaseServices.ApplicationId;
                    this.subscriptions.push(
                      this._flexiService
                        .generateOHSPDFInDocumnet(
                          this.Content,
                          this.businessId,
                          CultureInfo,
                          this.portalId,
                          this.ohsId,
                          this.userId,
                          this.featureId,
                          this.featureKey
                        )
                        .subscribe(
                          result => {
                            if (result) {
                              if (selectedData.length > 0) {
                                this._flexiService
                                  .SaveOHSToDetailsActivity(
                                    selectedData,
                                    this.businessId,
                                    this.applicationId,
                                    this.userId
                                  )
                                  .subscribe(result1 => {
                                    if (result1) {
                                      this.loading = false;
                                      this.resetForm();
                                    }
                                  });
                                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                              } else {
                                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                                this.loading = false;
                                this.resetForm();
                              }
                            }
                          },
                          error => {
                            
                            this.loading = false;
                          }
                        )
                    );
                  });
              }
            });
        };

        // Save editor content first, then proceed with activities + PDF generation
        if (this.ohsId != null && this.ohsId != 0) {
          this.Data = {
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };
          this._flexiService
            .updateOHSData(this.Data, this.ohsId)
            .subscribe(() => {
              proceedWithActivities();
            });
        } else {
          this.Data = {
            id: null,
            CreatedBy: BaseServices.UserId,
            Content: this.Content,
            BusinessId: BaseServices.BusinessId
          };
          this._flexiService.PostOHSData(this.Data).subscribe(() => {
            proceedWithActivities();
          });
        }
      }
    });
  }

  resetForm() {
    if (!this.canEdit) return;
    this.OHS_PerfomedDetails = new OHS_PerformedDetails();
    this.OHS_PerfomedDetails.OHS_Activity = [new OHS_Activty()];
    this.OHS_PerfomedDetails.OHS_Activity[0].No = 1;
    this.OHS_PerfomedDetails.OHS_Activity[0].Initiator = 1;
    this.OHS_PerfomedDetails.PerformedBy = '';
    this.OHS_PerfomedDetails.PeriodFrom = null;
    this.OHS_PerfomedDetails.PeriodTo = null;
    this.OHS_PerfomedDetails.OHS_PlanId = 0;
    this.OHS_PerfomedDetails.BusinessId = BaseServices.BusinessId;
    this.tabz.text = '';
    this.Content = '';
  }

  addNewRow(index: number) {
    if (!this.canEdit) return;
    let activity = new OHS_Activty();
    activity.Activity = '';
    activity.Comment = '';
    activity.OHS_Advise = false;
    activity.OHS_Not_Advise = false;
    activity.Initiator = 1;
    activity.RegisteredActivity = false;
    activity.Deadline = null;

    this.OHS_PerfomedDetails.OHS_Activity.splice(index + 1, 0, activity);

    for (let i = 0; i < this.OHS_PerfomedDetails.OHS_Activity.length; i++) {
      this.OHS_PerfomedDetails.OHS_Activity[i].No = i + 1;
    }

    if (this.OHS_PerfomedDetails.Id == 0) {
      this.isShowOHSPlanTable = true;
      let performedActivity = new OHS_PerformedDetails();
      performedActivity.PerformedBy = '';
      performedActivity.PeriodFrom = null;
      performedActivity.PeriodTo = null;
      performedActivity.OHS_PlanId = this.ohsId;
      performedActivity.BusinessId = BaseServices.BusinessId;
      this.OHS_PerfomedDetails = performedActivity;
      this.OHS_PerfomedDetails.OHS_Activity = [];
      this.OHS_PerfomedDetails.OHS_Activity.push(activity);
    }

    this.addnewrow = 1;
  }

  checkActivityDeadline(): boolean {
    for (const activity of this.OHS_PerfomedDetails.OHS_Activity) {
      if (!activity.Activity || !activity.Deadline) {
        return false;
      }
    }
    return true;
  }

  /**
   * Handles changes to the "From" date.
   * Sets the minimum selectable "To" date.
   * @param date The selected "From" date.
   */
  FromDateChanged(date: Date) {
    this.OptionDate = date;
    this.Optionstring = 'startDate';
    // Set the minimum selectable date for "To" calendar
    this.minToDate = HelperService.formatedInputDate(date);
    // Optionally, clear ToDate if it's before the new FromDate
    if (
      this.OHS_PerfomedDetails.PeriodTo &&
      this.minToDate &&
      this.OHS_PerfomedDetails.PeriodTo < this.minToDate
    ) {
      this.OHS_PerfomedDetails.PeriodTo = null;
    }
  }

  /**
   * Handles changes to the "To" date.
   * Sets the maximum selectable "From" date.
   * @param date The selected "To" date.
   */
  ToDateChanged(date: Date) {
    this.OptionDate = date;
    this.Optionstring = 'endDate';
    // Set the maximum selectable date for "From" calendar
    this.maxFromDate = HelperService.formatedInputDate(date);
    // Optionally, clear FromDate if it's after the new ToDate
    if (
      this.OHS_PerfomedDetails.PeriodFrom &&
      this.maxFromDate &&
      this.OHS_PerfomedDetails.PeriodFrom > this.maxFromDate
    ) {
      this.OHS_PerfomedDetails.PeriodFrom = null;
    }
  }
  dateChanged(date: Date, index: number) {
    if (!this.canEdit) return;
    this.OHS_PerfomedDetails.OHS_Activity[index].Deadline = date;
  }

  AddDefaultTemplate() {
    if (!this.canEdit) return;
    this.confirmationService.confirm({
      message: this.translate.instant('CONFIRM_THIS_RECORD'),
      accept: () => {
        this._flexiService.getDefaultOhsActivity().subscribe(result => {
          let performedActivity = new OHS_PerformedDetails();
          performedActivity.OHS_Activity = result;
          performedActivity.PerformedBy = this.OHS_PerfomedDetails.PerformedBy;
          this.OHS_PerfomedDetails = performedActivity;
          this.isShowOHSPlanTable = true;
        });
      }
    });
  }

  removeOhsActivity(index: number) {
    if (!this.canEdit) return;
    this.loading = true;
    if (this.addnewrow == 0) {
      this._flexiService
        .getOhsActivityDetailsById(this.ohsId)
        .subscribe(result => {
          const activity = result.OHS_Activity[index];
          const activityIdToDelete = activity.Id;
          this._flexiService
            .DeleteOhsActivity(activityIdToDelete)
            .subscribe(result => {
              if (result) {
                this.OHS_PerfomedDetails.OHS_Activity.splice(index, 1);
                this.updateActivityNumbers(index);
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
                this.loading = false;
              }
            });
        });
    } else {
      this.OHS_PerfomedDetails.OHS_Activity.splice(index, 1);
      this.updateActivityNumbers(index);
      this.loading = false;
      this.notifications.success('UI_NOTIFICATIONS.DELETED');
    }
  }

  updateActivityNumbers(startIndex: number) {
    for (
      let i = startIndex;
      i < this.OHS_PerfomedDetails.OHS_Activity.length;
      i++
    ) {
      this.OHS_PerfomedDetails.OHS_Activity[i].No = i + 1;
    }
  }

  selectOption(option: string, index: number) {
    if (!this.canEdit) return;
    if (option == 'OHS_Advise') {
      this.OHS_PerfomedDetails.OHS_Activity[index].OHS_Advise = true;
      this.OHS_PerfomedDetails.OHS_Activity[index].OHS_Not_Advise = false;
    } else {
      this.OHS_PerfomedDetails.OHS_Activity[index].OHS_Advise = false;
      this.OHS_PerfomedDetails.OHS_Activity[index].OHS_Not_Advise = true;
    }
  }
}
